<template>
    <span :class="ns.e('total')" :disabled="disabled">
        {{
            t('el.pagination.total', {
                total
            })
        }}
    </span>
</template>

<script lang="ts" setup>
import { useLocale } from '../hooks/use-locale';
import { useNamespace } from '../hooks/use-namespace';
import {usePagination} from '../usePagination';
import {paginationTotalProps} from './total';

const {t} = useLocale();
const ns = useNamespace('pagination');
const {disabled} = usePagination();

defineOptions({
    name: 'ElPaginationTotal'
});

defineProps(paginationTotalProps);
</script>